import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserCollectionDtoInterface} from '../user-collections/dto/user-collection-dto';

@Component({
  selector: 'app-user-item-delete-prompt',
  templateUrl: './user-item-delete-prompt.component.html',
  styleUrls: ['./user-item-delete-prompt.component.scss']
})
export class UserItemDeletePromptComponent {

  windowTitle: string;

  itemTitle: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  public closeModal() {
    this.activeModal.close(false);
  }

  public removeUserCollection() {
    this.activeModal.close(true);
  }

}
